import React, { useEffect, useRef } from 'react'

import './FilterBreakdownPopover.scss'

const OPERATOR_LABEL = {
    OR: 'One of',
    AND: 'All',
}

const FilterBreakdownPopover = ({
    ruleGroup,
    placement = 'left-top',
    onClose,
    onEdit,
    title = 'Response filters',
}) => {
    const ref = useRef(null)

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                onClose()
            }
        }
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                e.stopPropagation()
                onClose()
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        document.addEventListener('keydown', handleKeyDown)
        ref.current?.focus()
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [onClose])

    const placementStyles = (() => {
        const styles = { position: 'absolute', right: 'calc(100% + 8px)' }
        if (placement === 'left-bottom') styles.bottom = 0
        else styles.top = 0
        return styles
    })()

    const rules = ruleGroup?.rules ?? []

    return (
        <div
            ref={ref}
            className="pp-filter-breakdown"
            role="dialog"
            aria-label={title}
            tabIndex={-1}
            data-placement={placement}
            style={placementStyles}
            onClick={(e) => e.stopPropagation()}
        >
            <span className="pp-filter-breakdown__arrow" aria-hidden="true" />
            <div className="pp-filter-breakdown__header">
                <h5>{title}</h5>
                <div className="pp-filter-breakdown__actions">
                    {onEdit && (
                        <button type="button" onClick={onEdit}>Edit</button>
                    )}
                    <button
                        type="button"
                        className="pp-filter-breakdown__close"
                        aria-label="Close filter breakdown"
                        onClick={onClose}
                    >
                        <i className="fas fa-times" aria-hidden="true" />
                    </button>
                </div>
            </div>
            <div className="pp-filter-breakdown__body">
                {rules.map((entry, index) => {
                    if (entry.ruleType === 'logic') {
                        return (
                            <span
                                key={`logic-${entry.logic}-${index}`}
                                className="pp-filter-breakdown__logic"
                            >
                                {entry.logic}
                            </span>
                        )
                    }
                    return (
                        <div key={entry.id} className="pp-filter-breakdown__rule">
                            <span className="pp-filter-breakdown__rule-operator">
                                {OPERATOR_LABEL[entry.logic] ?? entry.logic}
                            </span>
                            <span className="pp-filter-breakdown__rule-label">{entry.label}</span>
                            <div className="pp-filter-breakdown__rule-values">
                                {entry.options.map((option) => (
                                    <span key={option.id}>{option.label}</span>
                                ))}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default FilterBreakdownPopover
